// The success notices after a merge or a prune commits. Shared by the three
// collection surfaces (the generic detail page, People, Places) so the
// message reads identically wherever the cleanup ran.

// "Merged — N check-ins re-pointed, M duplicates removed."
export function formatMergeSummary(repointed: number, reaped: number): string {
    const cPart = `${repointed} check-in${repointed === 1 ? '' : 's'} re-pointed`
    const rPart = `${reaped} duplicate${reaped === 1 ? '' : 's'} removed`
    return `Merged — ${cPart}, ${rPart}.`
}

// "Deleted N items", optionally noting any candidates skipped server-side
// because they gained a live reference.
export function formatPruneSummary(reaped: number, skipped: number): string {
    const base = `Deleted ${reaped} item${reaped === 1 ? '' : 's'}`
    return skipped > 0 ? `${base} (${skipped} skipped — newly referenced)` : base
}
